import React, { useState, useEffect } from 'react'
import { Header1, Text, SectionHeader } from '../../styles/Components'
import Button from '../../components/Button'
import { PackagesWrapper } from '../../components/packages/styles/curateur-page'
import MarketSelector from '../../components/MarketSelector'
import { gsColors as c } from '../../styles/Variables'
import SelectProductButton from '../../components/SelectProductButton'
import FAQ from '../../faq'
import { fetchSingleProduct } from '../../services'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { useMarketContext } from '../../components/MarketContext'

const FAQ_DATA_PACKAGES = [
  {
    id: 1,
    title: 'Why do I have an additional charge when my package is applied to my service?',
    body: 'There are a few scenarios where you may pay in addition to your existing package credits that have been applied to your appointment. If you have a package of blowouts and book for an updo which costs more, additional credits will be subtracted from your package to cover the cost of the updo. This will leave your package with an uneven amount of credits. When you use the last of your credits you will have an additional charge to cover what the credits did not cover in that appointment. If you have a blowout package and book a blowout plus a manicure, only the blowout package will apply and you will be charged for the manicure.',
  },
  {
    id: 2,
    title: 'How do packages work?',
    body: 'When you purchase a package you\'re essentially purchasing service credits at a discounted rate. For example, the cost for a package of 5 blowouts will be at a discounted rate plus the gratuity of the full service, the support fee, and tax if applicable. The credits you are given will reflect the full price of the services in your account once the transaction is complete.',
  },
  {
    id: 3,
    title: 'Why should I purchase a package?',
    body: 'Glamsquad isn\'t just for special occasions. Packages are a great way to save money for those who want to make looking and feeling great a regular part of their routine. Glamsquad package credits never expire!',
  },
]

export const getStaticProps = async () => {
  const product = await fetchSingleProduct(process.env.NEXT_PUBLIC_FABFITFUN_BUNDLE_ID)
  return { props: { product } }
}

const FAQ_URL = '/faq/category/service-packages'

const FabFitFunPackage = ({ product }) => {
  const router = useRouter()
  const { markets, selectedMarket, setSelectedMarket } = useMarketContext()

  // hero image is hardcoded to the height of the nav, which can change
  // with the banner.  This is a temporary solution until the UI gets refactored
  const [banner, setBanner] = useState(false)

  useEffect(() => {
    if (!product) {
      router.push('/')
    }
  }, [product, router])

  useEffect(() => {
    // conditionally push image down if nav banner exist on render
    setBanner(!!(document.querySelector('#banner')))
  }, [])


  if (!product) {
    return null
  }


  return (
    <PackagesWrapper banner={banner}
      bannerImagePath='/images/fabfitfun.jpg'
      bannerMobileImagePath='/images/fabfitfun_mobile.jpg'>
      <Head>
        <title>FabFitFun | Glamsquad</title>
      </Head>
      <div className='banner' />
      <div className="content">
        <div className="packages-content">
          <Header1>FabFitFun #RushTok Box Blowout Bundle</Header1>
          <Text
            className="subtitle"
            color={c.paleSlate}
            margin="15px 0"
            variant="large"
          >
            FabFitFun and Glamsquad are teaming up to offer you a special limited edition two for one blowout bundle. Receive two blowouts for the price of $60<super>*</super> ($120 value)&mdash; the perfect way for you to enjoy more of our signature service.
          </Text>
          <div className="package-steps">
            <div className="step-1">
              <SectionHeader small margin="15 0">
                Recipient Location
              </SectionHeader>
              <MarketSelector
                markets={markets}
                selected={selectedMarket}
                setSelected={setSelectedMarket}
              />
            </div>

            <div className="step-2" id="main-content" tabIndex="0">
              <Text
                className="subtitle"
                margin="15px 0"
                color={c.paleSlate}
                variant="small"
              >
                <super>*</super>Redeemable on new appointments only. Bundle expires on 12/30/23. Subject to availability. Taxes, fees and gratuities added at checkout.
              </Text>
              <div className="packages-container">
                <div className="package-card">
                  <div className="card-content">
                    <Text weight={700}>{product.name}</Text>
                    <Text margin="5px 0" color={c.saltBox} variant="small">
                      {product.description}
                    </Text>
                    <Text weight={700}>$60</Text>
                  </div>

                  <div className="card-cta">
                    <SelectProductButton
                      color={c.sunsetOrange}
                      product={product}
                      fromPath="/fabfitfun"
                    />
                  </div>
                </div>
                <Button
                  margin='1rem 0 0 0'
                  style={{ padding: '5px 0', minWidth: '0' }}
                  outline
                  noBorder
                  color={c.sunsetOrange}
                  path="/packages"
                >
                  Explore our other packages
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="faq-wrapper">
        <FAQ
          data={FAQ_DATA_PACKAGES}
          url={FAQ_URL}
        />
      </div>
    </PackagesWrapper>
  )
}

export default FabFitFunPackage
